var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4167 0.916626H1.91667C0.8625 0.916626 0 1.77913 0 2.83329V18.1666C0 19.2208 0.8625 20.0833 1.91667 20.0833H13.4167C14.4708 20.0833 15.3333 19.2208 15.3333 18.1666V2.83329C15.3333 1.77913 14.4708 0.916626 13.4167 0.916626ZM1.91667 2.83329H6.70833V10.5L4.3125 9.06246L1.91667 10.5V2.83329Z",
    fill: "#1D3557"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMe);
export default __webpack_public_path__ + "static/media/me.dd8fd4ef80568f297c522c52e4954bc0.svg";
export { ForwardRef as ReactComponent };